import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {
	readonly mobileLogo: string = "assets/images/Logo/JourneysLogoMobile.png";
	readonly journeyLogo: string = "assets/images/Logo/JourneysLogo.png";
	navLogo: string = "assets/images/Logo/JourneysLogo.png";

	logoChanged: any = null;
	private currentLogo: string = "assets/images/Logo/JourneysLogo.png";
	get logo(): string {
		return this.currentLogo;
	}
	set logo(logo: string) {
		this.currentLogo = logo;
		this.logoChanged.next(this.logoChanged.getValue() + 1);
	}
	resetLog(): void {
		this.logo = this.navLogo;
	}

	constructor() {
		this.logoChanged = new Rx.BehaviorSubject(1);
	}
}
